.base {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px;
  border-bottom: 1px solid color-mix(in srgb, var(--messageQuotedText) 15%, transparent);
}

.ghost {
  composes: base;
  align-items: center;
  gap: 8px;
  margin: 5px;
  padding: 5px;
}

.ghostLeft {
  flex: 0 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ghostHint {
  padding: 0 2px;
  font-size: 12px;
  color: color-mix(in srgb, var(--messageText) 60%, transparent);
}

.ghostCard {
  flex: 0 0 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #f4f6f9;
  border: 1px dashed rgba(16, 26, 38, 0.2);
  box-shadow: 0 2px 10px rgba(8, 14, 22, 0.1);
  width: 452px;
  max-width: 100%;
  box-sizing: border-box;
  transition: opacity 0.2s, filter 0.2s;
}

.ghostCardLoading {
  border-style: solid;
}
.ghostCardLoading .skelLine,
.ghostCardLoading .ghostThumb {
  background-image: linear-gradient(100deg, transparent 30%, rgba(255, 255, 255, 0.75) 50%, transparent 70%);
  background-size: 200% 100%;
  animation: shimmer 1.3s linear infinite;
}

@keyframes shimmer {
  from {
    background-position: 150% 0;
  }
  to {
    background-position: -50% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ghostCardLoading .skelLine,
  .ghostCardLoading .ghostThumb {
    animation: none;
    background-image: none;
  }
}
.ghostCardMuted {
  border-style: solid;
  opacity: 0.55;
  filter: grayscale(1);
}

.ghostBody {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.skelLine {
  width: 62%;
  height: 11px;
  border-radius: 4px;
  background: rgba(16, 26, 38, 0.17);
}

.skelLineShort {
  width: 90%;
  height: 8px;
  background: rgba(16, 26, 38, 0.1);
}

.ghostHost {
  margin-top: 2px;
  font-size: 12.5px;
  font-weight: 650;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #0e7f5b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ghostThumb {
  flex: 0 0 auto;
  width: 60px;
  height: 60px;
  border-radius: 10px;
  background: #dfe4ea;
}

.ghostActions {
  flex: 0 0 auto;
  margin-inline-start: auto;
  display: flex;
  align-items: center;
  gap: 4px;
}

.ready {
  composes: base;
  align-items: center;
}

.bar {
  composes: base;
  gap: 8px;
}

.barLabel {
  font-size: 13px;
  color: color-mix(in srgb, var(--messageText) 70%, transparent);
}

.preview {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
  max-height: 220px;
  object-fit: contain;
  object-position: left center;
  border-radius: 6px;
}

.readyControls {
  flex: 0 0 auto;
  margin-inline-start: auto;
  display: flex;
  align-items: center;
  gap: 4px;
}

.labelButton {
  flex: 0 0 auto;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 6px;
  white-space: nowrap;
  color: color-mix(in srgb, var(--messageText) 75%, transparent);
}
.labelButton:hover {
  background: color-mix(in srgb, var(--messageText) 10%, transparent);
}
.labelButton:focus-visible {
  outline: 2px solid var(--colorPrimary, #415e6b);
  outline-offset: 1px;
}

.addButton {
  flex: 0 0 auto;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  background: var(--colorPrimary, #415e6b);
}
.addButton:hover {
  filter: brightness(1.06);
}
.addButton:focus-visible {
  outline: 2px solid var(--colorPrimary, #415e6b);
  outline-offset: 2px;
}